export const PUBLIC_ROUTE = {
    LANDING: '/',
    SIGN_IN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    PAGE_404: '/404',
    PAGE_500: '/500',
};
